(function () {
  function getRootDomain() {
    var host = location.hostname;
    if (host.endsWith('.onthatass.com')) return '.onthatass.com';
    if (host.endsWith('.onthatass.dev')) return '.onthatass.dev';
    return host;
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; Path=/; Max-Age=' + maxAge +
      '; Domain=' + getRootDomain() +
      '; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }

  var params = new URLSearchParams(window.location.search);
  var userId = params.get('userId');

  if (userId) {
    setCookie('ota-uid', userId, 5);
  }
})();
